import { render, staticRenderFns } from "./videoView.vue?vue&type=template&id=0a147bd4&scoped=true&"
import script from "./videoView.vue?vue&type=script&lang=js&"
export * from "./videoView.vue?vue&type=script&lang=js&"
import style0 from "./videoView.vue?vue&type=style&index=0&id=0a147bd4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a147bd4",
  null
  
)

export default component.exports